import {EntityField} from "../../core/genericdocuments/EntityField"
import {EntityFieldDataType} from "../../core/genericdocuments/EntityFieldDataType"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails"
import {Employee} from "../../models/Employee"

export const employeeFields: IntercateKeysMap<Employee, EntityField<Employee>> = {
    id: {
		name: "id", dataType: EntityFieldDataType._string, label: "Id zaposlenog",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    firstName: {
		name: "firstName", dataType: EntityFieldDataType._string, label: "Ime",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    lastName: {
		name: "lastName", dataType: EntityFieldDataType._string, label: "Prezime",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    personalId: {
		name: "personalId", dataType: EntityFieldDataType._number, label: "JMBG",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    birthDate: {
		name: "birthDate", dataType: EntityFieldDataType._date, label: "Datum rođenja",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    positionId: {
        name: "positionId", dataType: EntityFieldDataType._reference, label: "Pozicija",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Positions
		},
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    address: {
		name: "address", dataType: EntityFieldDataType._string, label: "Adresa",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    phone: {
		name: "phone", dataType: EntityFieldDataType._string, label: "Telefon",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    insuranceId: {
		name: "insuranceId", dataType: EntityFieldDataType._number, label: "LBO",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    educationLevel: {
		name: "educationLevel", dataType: EntityFieldDataType._reference, label: "Nivo obrazovanja",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.EducationLevelTypes
		},
		validator: { required: false },
		sortable: true
	},
    contractType: {
		name: "contractType", dataType: EntityFieldDataType._reference, label: "Tip ugovora",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.ContractTypes
		},
		validator: { required: false },
		sortable: true
	},
    contractEndDate: {
		name: "contractEndDate", dataType: EntityFieldDataType._date, label: "Datum isteka ugovora",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    userId: {
		name: "userId", dataType: EntityFieldDataType._reference, label: "Korisnik",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Users
		},
		validator: { required: false },
		sortable: true
	},
}

const employeeFieldsArray: Array<EntityField<Employee>> = [
	employeeFields.firstName,
	employeeFields.lastName,
	employeeFields.personalId,
    employeeFields.birthDate,
    employeeFields.positionId,
    employeeFields.address,
    employeeFields.phone,
    employeeFields.insuranceId,
    employeeFields.educationLevel,
    employeeFields.contractType,
    employeeFields.contractEndDate,
    employeeFields.userId,
]

export const employeeFieldsDescriptor: EntityFieldsDescriptor<Employee> = {
	listFields: employeeFieldsArray,
	createFormFields: employeeFieldsArray,
	updateFormFields: employeeFieldsArray
}